/// <amd-dependency path='VSS/LoaderPlugins/Css!WorkItemArea' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import WITBulkEdit = require("WorkItemTracking/Scripts/TFS.WorkItemTracking.Controls.BulkEdit");
import Dialogs = require("VSS/Controls/Dialogs");

export interface ITestCaseBulkEditProps {
    testCaseIds: number[];
    projectTypeMapping: IDictionaryStringTo<string[]>;
    okCallback(dialogResult: any): void;
}

// This is a proxy component to load the edit test case(s) dialog using LegacyComponent
class TestCaseBulkEditProxy extends React.Component<ITestCaseBulkEditProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        Dialogs.show(WITBulkEdit.BulkEditWorkItemDialog, {
            workItemIds: this.props.testCaseIds,
            width: 600,
            minWidth: 450,
            height: 450,
            minHeight: 300,
            attachResize: true,
            tfsContext: TFS_Host_TfsContext.TfsContext.getDefault(),
            okCallback: (dialogResult: any) => {
                let bulkOptions = {
                    immediateSave: true,
                    afterSave: (workItems:any, changes: any, allWorkItemsUpdated: boolean) => {
                        if(allWorkItemsUpdated){
                            this.props.okCallback(dialogResult);
                        }
                    }
                };
                WITBulkEdit.bulkUpdateWorkItems(
                    TFS_Host_TfsContext.TfsContext.getDefault(),
                    dialogResult.workItemIds,
                    dialogResult.changes,
                    bulkOptions
                );
            },
            projectTypeMapping: this.props.projectTypeMapping
        });
    }
}

registerLWPComponent("testcase-bulk-edit-proxy", TestCaseBulkEditProxy);
